import { useQuery } from '@tanstack/react-query';
import { getSICReportById } from '@/services/ops.service';
import type { SICReportDetail } from '@/types/sic-report.types';
import { buildMockReportDetail } from '../mock/sic-mock-data';

const USE_MOCK = false;

const DETAIL_KEY = (reportId: string, partnerId: string, runDate: string) =>
    ['sic-detail', reportId, partnerId, runDate];

export function useSICReportDetail(
    reportId: string | undefined,
    partnerId: string,
    runDate: string | undefined,
) {
    const detailQuery = useQuery({
        queryKey: DETAIL_KEY(reportId ?? '', partnerId, runDate ?? ''),
        queryFn: async (): Promise<SICReportDetail> => {
            if (!reportId || !runDate) throw new Error('reportId y runDate son requeridos');
            if (USE_MOCK) {
                await new Promise((r) => setTimeout(r, 600));
                return buildMockReportDetail(reportId, partnerId, runDate);
            }
            const res = await getSICReportById(reportId, partnerId, runDate);
            return res.data;
        },
        enabled: !!reportId && !!runDate,
        staleTime: 60_000,
    });

    return {
        detail: detailQuery.data,
        isLoading: detailQuery.isLoading,
        error: detailQuery.error,
    };
}
